import css from 'styled-jsx/css';

const styles = css`/**
 * Do not edit directly
 * Generated on Thu, 30 Sep 2021 15:04:20 GMT
 */

.hidden {
	visibility: hidden;
}

.visible {
	visibility: visible;
}

.bottom {
	display: flex;
	flex-direction: column-reverse;
}

.top {
	display: flex;
	flex-direction: column;
}

.trp-popover-wrapper {
	width: -webkit-max-content;
	width: -moz-max-content;
	width: max-content;
	max-width: 288px;
	position: fixed;
}

.trp-popover-arrow-left {
	justify-content: flex-start;
	margin-left: 24px;
}

.trp-popover-arrow-middle {
	justify-content: center;
}

.trp-popover-arrow-right {
	justify-content: flex-end;
	margin-right: 24px;
}

.trp-popover-arrow-wrapper {
	display: none;
}

.trp-popover-surface {
  	background-color: #1E2D39;
	border-radius: 4px;
	box-shadow: 0px 2px 4px -2px rgba(146, 155, 163, .8);
	max-width: 288px;
	padding: 8px;
}

.trp-popover-zones-wrapper {
	margin: 8px;
}

.trp-popover-surface .trp-popover-title-wrapper {
    display: flex;
    max-width: 232px;
    padding: 8px;
}

.trp-popover-surface .trp-popover-title-wrapper h2 {
	color: #D3D7DA;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	margin: 0;
}

.trp-popover-close-button {
    background: no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cpath d='M27 13L13 27' stroke='%23FFFFFF' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M27 27L13 13' stroke='%23FFFFFF' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
    cursor: pointer;
    height: 40px;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 40px;
}

.trp-popover-surface .trp-popover-content-wrapper {
	max-width: 272px;
	padding: 8px 8px calc(8px*2) 8px;
	text-align: left;
}

.trp-popover-content-wrapper span {
	color: #D3D7DA;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin: 0;
}

.trp-popover-content-wrapper span *:first-child {
	margin-top: 0;
}

.trp-popover-content-wrapper span *:last-child {
	margin-bottom: 0;
}

@media screen and (min-width: 640px) {
	.trp-popover-wrapper {
		max-width: 340px;
	}

	.trp-popover-arrow-wrapper {
		display: flex;
	}

	.trp-popover-surface {
		max-width: 340px;
	}

	.trp-popover-surface .trp-popover-title-wrapper {
		max-width: 292px;
	}

	.trp-popover-surface .trp-popover-title-wrapper h2 {
		font-size: 16px;
		line-height: 24px;
	}

	.trp-popover-surface .trp-popover-close-button {
		display: none;
	}

	.trp-popover-surface .trp-popover-content-wrapper {
		max-width: 292px;
	}

	.trp-popover-surface .trp-popover-content-wrapper span {
		font-size: 16px;
		line-height: 24px;
	}
}

@media screen and (min-width: 960px) {
	.trp-popover-wrapper {
		max-width: 340px;
	}

	.trp-popover-arrow-wrapper {
		display: flex;
	}

	.trp-popover-surface {
		max-width: 340px;
	}

	.trp-popover-surface .trp-popover-title-wrapper {
		max-width: 292px;
	}

	.trp-popover-surface .trp-popover-title-wrapper h2 {
		font-size: 16px;
		line-height: 24px;
	}

	.trp-popover-surface .trp-popover-title-wrapper .trp-popover-close-button {
		display: none;
	}

	.trp-popover-surface .trp-popover-content-wrapper {
		max-width: 292px;
	}

	.trp-popover-surface .trp-popover-content-wrapper span {
		font-size: 16px;
		line-height: 24px;
	}
}

@media screen and (min-width: 1280px) {
	.trp-popover-wrapper {
		max-width: 396px;
	}

	.trp-popover-arrow-wrapper {
		display: flex;
	}

	.trp-popover-surface {
		max-width: 396px;
	}

	.trp-popover-surface .trp-popover-title-wrapper {
		max-width: 348px;
	}

	.trp-popover-surface .trp-popover-title-wrapper h2 {
		font-size: 18px;
		line-height: 24px;
	}

	.trp-popover-surface .trp-popover-title-wrapper .trp-popover-close-button {
		display: none;
	}

	.trp-popover-surface .trp-popover-content-wrapper {
		max-width: 348px;
	}

	.trp-popover-surface .trp-popover-content-wrapper span {
		font-size: 18px;
		line-height: 24px;
	}
}

.trp-popover-arrow-wrapper .trp-popover-arrow-top {
  background: no-repeat url("data:image/svg+xml;utf8,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z' fill='%231E2D39'%3E%3C/path%3E%3C/svg%3E");
  height: 6px;
  width: 12px;
}

.trp-popover-arrow-wrapper .trp-popover-arrow-bottom {
	background: no-repeat url("data:image/svg+xml;utf8,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg' style='transform: rotate(180deg);'%3E%3Cpath d='M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z' fill='%231E2D39'%3E%3C/path%3E%3C/svg%3E");
	height: 6px;
	width: 12px;
}
`;

export default styles;